import { SET_RESERVATION_INFO, REMOVE_RESERVATION_INFO, CHANGE_RESERVATION_STATUS } from '@/store/mutation-types';
import { IReservationRegisterOptions } from '@/types/reservation';
import { Commit } from 'vuex';

const initState: IReservationRegisterOptions = {
  content: null,
  type: '',
  changedContentId: null
};

const actions = {
  setRegisteringContent(
    context: { commit: Commit; state: IReservationRegisterOptions },
    payload: IReservationRegisterOptions
  ) {
    context.commit(SET_RESERVATION_INFO, payload);
  },
  removeRegisteringContent(context: { commit: Commit; state: IReservationRegisterOptions }) {
    context.commit(REMOVE_RESERVATION_INFO);
  },
  setChangedContentId(context: { commit: Commit; state: IReservationRegisterOptions }, payload: number) {
    context.commit(CHANGE_RESERVATION_STATUS, payload);
  }
};

const mutations = {
  [SET_RESERVATION_INFO]: (state: IReservationRegisterOptions, payload: IReservationRegisterOptions) => {
    state.content = payload.content;
    state.type = payload.type;
  },
  [REMOVE_RESERVATION_INFO]: (state: IReservationRegisterOptions) => {
    state.content = null;
  },
  [CHANGE_RESERVATION_STATUS]: (state: IReservationRegisterOptions, payload: number) => {
    state.changedContentId = payload;
  }
};

const getters = {
  registeringContent: (state: IReservationRegisterOptions) => {
    return {
      content: state.content,
      type: state.type
    };
  },
  changedContentId: (state: IReservationRegisterOptions) => state.changedContentId
};

export default {
  state: initState,
  mutations,
  actions,
  getters
};
